<template>
  <v-app>
    <v-app-bar
      app
      dark
      dense
      color="primary"
      clipped
    >
      <router-link to="/">
        <v-img
          src="/favicon.ico"
          alt="Лого"
          max-width="32"
          width="32"
        />
      </router-link>
      <v-toolbar-title class="ml-0 pl-4">
        <span>{{this.$store.state.appTitle}}</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Выпадающий список: выход, профиль -->
      <Account v-if="$store.state.auth.user"/>
    </v-app-bar>

    <router-view />

    <v-footer
      app
      color="primary"
      dark
    >&#169; Фортуна 2020</v-footer>

    <Messages></Messages>
    <ConfirmDialog></ConfirmDialog>
    <Loading></Loading>
  </v-app>
</template>

<script>
import Account from '@/components/Account'
import Loading from '@/components/Loading'
import Messages from '@/components/Messages'
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: {
    Loading, Messages, ConfirmDialog, Account
  },

  created () {
    if (this.$workbox) {
      this.$workbox.addEventListener('waiting', () => {
        console.log('this.showUpgradeUI = true')
        this.showUpgradeUI = true
      })
    }
  },

  methods: {
    async accept () {
      this.showUpgradeUI = false
      console.log('this.showUpgradeUI = false')
      await this.$workbox.messageSW({ type: 'SKIP_WAITING' })
    }
  }
}
</script>
